module.exports = __webpack_public_path__ + "statics/img/18.9571f11.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/wap/18.png
// module id = 1Kf6
// module chunks = 1